import type { ReactNode } from 'react';
import { ArrowRight, Layers3, ShieldCheck } from 'lucide-react';

export function AdminAccessFrame({ children, step }: { children: ReactNode; step: 1 | 2 }) {
  return (
    <div className="min-h-dvh bg-background lg:grid lg:grid-cols-[minmax(320px,0.8fr)_minmax(0,1.2fr)]">
      <aside className="flex flex-col justify-between bg-[#111e35] px-6 py-7 text-white sm:px-10 lg:min-h-dvh lg:px-14 lg:py-12">
        <div className="flex items-center gap-3">
          <Layers3 className="h-7 w-7 text-blue-300" strokeWidth={1.6} aria-hidden="true" />
          <div><p className="text-lg font-semibold tracking-tight">UGOT</p><p className="text-xs text-slate-300">Admin Console</p></div>
        </div>
        <div className="hidden max-w-md py-16 lg:block">
          <p className="mb-5 text-xs font-medium tracking-widest text-slate-300">SERVICE OPERATIONS</p>
          <h2 className="text-4xl font-semibold leading-snug tracking-tight">서비스 운영을<br />한곳에서.</h2>
          <p className="mt-6 text-sm leading-7 text-slate-300">계정과 이용 권한, 결제와 구독 이력을 확인하고<br />서비스에 필요한 운영 업무를 관리합니다.</p>
          <div className="mt-12 border-t border-white/15 pt-6">
            <div className="flex items-center gap-3 text-sm text-slate-200"><ShieldCheck className="h-4 w-4" aria-hidden="true" />관리자 전용 워크스페이스</div>
          </div>
        </div>
        <p className="hidden text-xs text-slate-400 lg:block">UGOT · 서비스 관리</p>
      </aside>
      <main id="main-content" className="flex min-w-0 flex-col justify-center px-5 py-10 sm:px-10 lg:px-16">
        <div className="mx-auto w-full max-w-md">
          <ol aria-label="관리자 로그인 단계" className="mb-10 flex items-center gap-3 text-xs text-muted-foreground">
            <li aria-current={step === 1 ? 'step' : undefined} className={step === 1 ? 'font-semibold text-foreground' : ''}>01 계정 로그인</li>
            <ArrowRight className="h-3 w-3" aria-hidden="true" />
            <li aria-current={step === 2 ? 'step' : undefined} className={step === 2 ? 'font-semibold text-foreground' : ''}>02 관리자 인증</li>
          </ol>
          {children}
          <p className="mt-8 border-t pt-5 text-xs leading-relaxed text-muted-foreground">접근 권한이 있는 관리자 계정으로 이용해 주세요.</p>
        </div>
      </main>
    </div>
  );
}
